export const ADD = 'add'
export const BRANDING = 'branding'
export const DATA = 'data'
export const SCREENS = 'screens'
export const SETTINGS = 'settings'
export const PUBLISH = 'publish'
export const ANALYTICS = 'analytics'
export const VERSIONS = 'versions'
